import { render, staticRenderFns } from "./ModalOrderView.vue?vue&type=template&id=20a99362&scoped=true&"
import script from "./ModalOrderView.vue?vue&type=script&lang=js&"
export * from "./ModalOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a99362",
  null
  
)

export default component.exports